<script>
     export let angebot; 
     let src = "./images/bgg.png";
</script>

<style>
    .bgg{display: flex;}
 img{
    height:1.2em;
   width:1.2 em;
 }
</style>

    <div class = "bgg"><a href="https://boardgamegeek.com/boardgame/{angebot.objectid}" target=_blank><img {src} alt="Boardgamegeek Icon" /></a> </div> 

<!-- markup (zero or more items) goes here -->